import React, { useEffect, useRef, useState, useContext } from "react";
import PageHeader from "../pageheader/PageHeader";
import ManuOperation from "./navOperationRoom/ManuOperation";

import styles from "./AddOperationStaff.module.css";
import Input from "../material/input/Input";
import Select from "../material/select/Select";
import Button from "../material/button/Button";
import PasswordInput from "../material/passwordInput/PasswordInput";
import Datepicker from "../material/datepicker/Datepicker";
import moment from "moment";
import * as regex from "../../service/regex";
import { useLocation, useNavigate } from "react-router";
import * as publicApi from "../../service/publicApi";

import { CurrentUserContext } from "../../App";

function AddOperationStaff() {
  const { setIsMessage } = useContext(CurrentUserContext);

  const nav = useNavigate();
  const location = useLocation();
  const [loading, setLoading] = useState(false);

  const [pname, setPname] = useState("");
  const [optionPname, setOptionpPname] = useState([
    {
      key: "นาย",
      value: "นาย",
    },
    {
      key: "นาง",
      value: "นาง",
    },
    {
      key: "นางสาว",
      value: "นางสาว",
    },
  ]);
  const [fname, setFname] = useState("");
  const [lname, setLname] = useState("");
  const [gender, setGender] = useState("");
  let genderList = [
    {
      key: "male",
      value: "ชาย",
    },
    {
      key: "female",
      value: "หญิง",
    },
  ];
  const [pid, setPid] = useState("");
  const [behindIDCard, setBehindIDCard] = useState("");
  const [position, setPosition] = useState("");

  const [profLicenseId, setProfLicenseId] = useState("");
  const [email, setEmail] = useState("");
  const [phoneNumber, setPhoneNumber] = useState("");
  const [duty, setDuty] = useState("");
  const [password, setPassword] = useState("");
  const [confirmPassword, setconfirmPassword] = useState("");
  const [userName, setUserName] = useState("");

  const [address, setAddress] = useState("");
  const [moo, setMoo] = useState("");
  const [soy, setSoy] = useState("");
  const [road, setRoad] = useState("");
  const [postCode, setPostCode] = useState("");
  const [provinceId, setProvinceId] = useState("");
  const [districtId, setDistrictId] = useState("");
  const [subDistrictId, setSubDistrictId] = useState("");

  const [provinceList, setProvinceList] = useState([]);
  const [districtList, setDistrictList] = useState([]);
  const [subDistrictList, setSubDistrictList] = useState([]);

  const [birthday, setBirthday] = useState(null);

  const [day, setDay] = useState("");
  const [dayList, setDayList] = useState([]);
  const [month, setMonth] = useState("");
  const [monthList, setMonthList] = useState([]);
  const [year, setYear] = useState("");
  const [yearList, setYearList] = useState([]);

  const [analystCheck, setAnalystCheck] = useState(false);
  const [approverCheck, setApproverCheck] = useState(false);

  const inputFileRef = useRef(null);
  const [attachFile, setAttachFile] = useState(null);

  const user = JSON.parse(localStorage.getItem("user"));

  useEffect(() => {
    // console.log(user)
    const fetchData = async () => {
      await getProvinceList();
    };
    fetchData().then(() => {
      if (location.state) {
        filterData();
      }
    });
  }, []);

  useEffect(() => {
    let dList = [];
    dList.push({ key: "", value: "ไม่ทราบวันเกิด" });
    for (let i = 0; i < 31; i += 1) {
      dList.push({
        key: String(i + 1).padStart(2, "0"),
        value: i + 1 + "",
      });
    }
    setDayList(dList);

    let mList = [
      {
        key: "",
        value: "ไม่ทราบเดือนเกิด",
      },
      {
        key: "01",
        value: "มกราคม",
      },
      {
        key: "02",
        value: "กุมภาพันธ์",
      },
      {
        key: "03",
        value: "มีนาคม",
      },
      {
        key: "04",
        value: "เมษายน",
      },
      {
        key: "05",
        value: "พฤษภาคม",
      },
      {
        key: "06",
        value: "มิถุนายน",
      },
      {
        key: "07",
        value: "กรกฎาคม",
      },
      {
        key: "08",
        value: "สิงหาคม",
      },
      {
        key: "09",
        value: "กันยายน",
      },
      {
        key: "10",
        value: "ตุลาคม",
      },
      {
        key: "11",
        value: "พฤศจิกายน",
      },
      {
        key: "12",
        value: "ธันวาคม",
      },
    ];
    setMonthList(mList);

    let yList = [];
    yList.push({ key: "", value: "ไม่ทราบปีเกิด" });
    let currentYear = moment().format("YYYY");
    for (let i = 0; i < 100; i += 1) {
      yList.push({
        key: currentYear - i + "",
        value: currentYear - i + 543 + "",
      });
    }
    setYearList(yList);
  }, []);

  const filterData = () => {
    let data = location.state;
    // console.log(data)
    setPname(data.pname);
    setFname(data.fname);
    setLname(data.lname);
    setPid(data.pid);
    setBehindIDCard(data.behindIDCard);
    setGender(data.gender);
    setPosition(data.position);
    setProfLicenseId(data.profLicenseId);

    if (data.birthday) {
      setBirthday(data.birthday);
    }
    // setDay(data.day)
    // setMonth(data.month)
    // setYear(data.year)
    setPhoneNumber(data.phoneNumber);
    setEmail(data.email);
    setAddress(data.address);
    setMoo(data.moo);
    setSoy(data.soy);
    setRoad(data.road);
    setProvinceId(data.provinceId);
    setDistrictId(data.districtId);
    setSubDistrictId(data.subDistrictId);
    setPostCode(data.postCode);
    setProvinceList(data.provinceList);
    setDistrictList(data.districtList);
    setSubDistrictList(data.subDistrictList);
    setAnalystCheck(data.analystCheck);
    setApproverCheck(data.approverCheck);
    setAttachFile(data.attachFile);
    setUserName(data.userName);
    setPassword(data.password);
    setconfirmPassword(data.confirmPassword);
  };

  const getProvinceList = async () => {
    setLoading(true);
    let res = await publicApi.getProvinceList();
    setLoading(false);
    if (res) {
      if (res["data"]["code"] === 200) {
        setProvinceList(
          res["data"]["province_list"].map((item) => {
            return {
              key: item["province_id"],
              value: item["province_name"],
            };
          }),
        );
      } else {
        setIsMessage({
          type: "warning",
          data: res["data"]["message_th"] || res["data"]["message"],
        });
      }
    } else {
      setIsMessage({
        type: "error",
        data: "เกิดปัญหาการใช้งาน กรุณาติดต่อเจ้าหน้าที่",
      });
    }
  };

  const getDistrictList = async (id) => {
    setLoading(true);
    let res = await publicApi.getDistrictList(id);
    setLoading(false);
    if (res) {
      if (res["data"]["code"] === 200) {
        setDistrictList(
          res["data"]["district_list"].map((item) => {
            return {
              key: item["district_id"],
              value: item["district_name"],
            };
          }),
        );
      } else {
        setIsMessage({
          type: "warning",
          data: res["data"]["message_th"] || res["data"]["message"],
        });
      }
    } else {
      setIsMessage({
        type: "error",
        data: "เกิดปัญหาการใช้งาน กรุณาติดต่อเจ้าหน้าที่",
      });
    }
  };

  const getSubDistrictList = async (id) => {
    setLoading(true);
    let res = await publicApi.getSubDistrictList(id);
    setLoading(false);
    if (res) {
      if (res["data"]["code"] === 200) {
        setSubDistrictList(
          res["data"]["sub_district_list"].map((item) => {
            return {
              key: item["sub_district_id"],
              value: item["sub_district_name"],
            };
          }),
        );
      } else {
        setIsMessage({
          type: "warning",
          data: res["data"]["message_th"] || res["data"]["message"],
        });
      }
    } else {
      setIsMessage({
        type: "error",
        data: "เกิดปัญหาการใช้งาน กรุณาติดต่อเจ้าหน้าที่",
      });
    }
  };

  const inputFileChange = async (event) => {
    // console.log(event.target.files[0])
    let fileObj = event.target.files && event.target.files[0];

    let formData = new FormData();
    formData.append("file", fileObj);
    formData.append("file_name", fileObj.name);

    setLoading(true);
    let res = await publicApi.attachment(formData);
    setLoading(false);
    if (res) {
      if (res["data"]["code"] === 200) {
        setAttachFile(res["data"]["file"]);
      } else {
        setIsMessage({
          type: "warning",
          data: res["data"]["message_th"] || res["data"]["message"],
        });
      }
    } else {
      setIsMessage({
        type: "error",
        data: "เกิดปัญหาการใช้งาน กรุณาติดต่อเจ้าหน้าที่",
      });
    }
  };

  const submitButtonClick = () => {
    if (!pname) {
      setIsMessage({ type: "warning", data: "กรุณาเลือกคำนำหน้า" });
      return;
    }
    if (!fname) {
      setIsMessage({ type: "warning", data: "กรุณากรอกชื่อ" });
      return;
    }
    if (!pname) {
      setIsMessage({ type: "warning", data: "กรุณากรอกนามสกุล" });
      return;
    }
    if (!pid) {
      setIsMessage({ type: "warning", data: "กรุณากรอกเลขประจำตัวประชาชน" });
      return;
    }
    if (!behindIDCard) {
      setIsMessage({ type: "warning", data: "กรุณากรอกเลขหลังบัตรประชาชน" });
      return;
    }
    if (!position) {
      setIsMessage({ type: "warning", data: "กรุณากรอกตำแหน่ง" });
      return;
    }
    if (!profLicenseId && !attachFile) {
      setIsMessage({
        type: "warning",
        data: "กรุณาแนบไฟล์หรือกรอกเลขใบประกอบวิชาชีพ",
      });
      return;
    }
    if (!birthday) {
      setIsMessage({ type: "warning", data: "กรุณาเลือกวันเกิด" });
      return;
    }
    // if (!day) {
    //     setIsMessage('กรุณาเลือกวันเกิด')
    //     return
    // }
    // if (!month) {
    //     setIsMessage('กรุณาเลือกเดือนเกิด')
    //     return
    // }
    // if (!year) {
    //     setIsMessage('กรุณาเลือกปีเกิด')
    //     return
    // }
    if (!phoneNumber) {
      setIsMessage({ type: "warning", data: "กรุณากรอกเบอร์โทรศัพท์" });
      return;
    }
    if (!userName) {
      setIsMessage({ type: "warning", data: "กรุณากรอกชื่อผู้ใช้งาน" });
      return;
    }
    if (!password) {
      setIsMessage({ type: "warning", data: "กรุณากรอกรหัสผ่าน" });
    }
    if (!confirmPassword) {
      setIsMessage({ type: "warning", data: "กรุณากรอกยืนยันรหัสผ่าน" });
      return;
    }
    if (password !== confirmPassword) {
      setIsMessage({ type: "warning", data: "รหัสผ่านไม่ตรงกัน" });
      return;
    }
    if (!gender) {
      setIsMessage({ type: "warning", data: "กรุณาเลือกเพศ" });
      return;
    }
    // if (!address) {
    //     setIsMessage('กรุณากรอกที่อยู่')
    //     return
    // }
    // if (!moo) {
    //     setIsMessage('กรุณากรอกหมู่')
    //     return
    // }
    // if (!soy) {
    //     setIsMessage('กรุณากรอกซอย')
    //     return
    // }
    // if (!road) {
    //     setIsMessage('กรุณากรอกถนน')
    //     return
    // }
    if (!postCode) {
      setIsMessage({ type: "warning", data: "กรุณากรอกรหัสไปรษณีย์" });
      return;
    }
    // if (!provinceId) {
    //     setIsMessage('กรุณาเลือกจังหวัด')
    //     return
    // }
    // if (!districtId) {
    //     setIsMessage('กรุณาเลือกอำเภอ')
    //     return
    // }
    // if (!subDistrictId) {
    //     setIsMessage('กรุณาเลือกตำบล')
    //     return
    // }

    nav("/permissionStaffOperation", {
      state: {
        pname,
        fname,
        lname,
        pid,
        behindIDCard,
        position,
        gender,
        profLicenseId,
        analystCheck,
        approverCheck,
        attachFile,
        birthday,
        phoneNumber,
        email,
        userName,
        password,
        confirmPassword,
        address,
        moo,
        soy,
        road,
        provinceId,
        districtId,
        subDistrictId,
        postCode,
        // provinceList, districtList, subDistrictList
      },
    });
  };

  return (
    <div className="global-page">
      <ManuOperation />
      <PageHeader
        titlename={"เพิ่มเจ้าหน้าที่ห้องปฏิบัติการ"}
        btnBackWard
        backpath="/manageUsersOperation"
      />
      <div className={styles.container}>
        <div className={styles.title}>ข้อมูลผู้ปฏิบัติการ</div>
        <div className={styles.alignAll}>
          <Select
            placeholder="เลือกคำนำหน้า"
            value={pname}
            setValue={setPname}
            list={optionPname}
          />
          <div></div>
          <Input placeholder="ชื่อ" value={fname} setValue={setFname} />
          <Input placeholder="นามสกุล" value={lname} setValue={setLname} />
          <Input
            regex={regex.pid()}
            placeholder="เลขบัตรประจำตัวประชาชน"
            value={pid}
            setValue={setPid}
          />
          <Input
            regex={regex.laserId()}
            placeholder="เลขหลังบัตรประจำตัวประชาชน"
            value={behindIDCard}
            setValue={setBehindIDCard}
          />
          <Select
            label="เพศ"
            placeholder="เพศ"
            value={gender}
            setValue={setGender}
            list={genderList}
          ></Select>
          <Input
            placeholder="ตำแหน่ง"
            value={position}
            setValue={setPosition}
          />
          <Input
            placeholder="เลขใบประกอบวิชาชีพ"
            value={profLicenseId}
            setValue={setProfLicenseId}
          />
          <Datepicker
            label="วันเกิด"
            value={birthday}
            setValue={setBirthday}
          ></Datepicker>
          {/* <Select placeholder='วันเกิด' list={dayList} value={day} setValue={setDay} />
                    <Select placeholder='เดือนเกิด' list={monthList} value={month} setValue={setMonth} />
                    <Select placeholder='ปีเกิด' list={yearList} value={year} setValue={setYear} /> */}
          <Input
            placeholder="เบอร์โทรศัพท์"
            value={phoneNumber}
            setValue={setPhoneNumber}
          />
          <Input
            type="email"
            placeholder="Email (ถ้ามี)"
            value={email}
            setValue={setEmail}
          />
        </div>
        <div className={styles.title}>ที่อยู่</div>
        <div className={styles.alignAll}>
          {/* <Input placeholder="ที่อยู่" value={address} setValue={setAddress}></Input>
                    <Input placeholder="หมู่" value={moo} setValue={setMoo}></Input>
                    <Input placeholder="ซอย" value={soy} setValue={setSoy}></Input>
                    <Input placeholder="ถนน" value={road} setValue={setRoad}></Input>
                    <Select placeholder="จังหวัด" value={provinceId} setValue={(e) => {
                        setProvinceId(e)
                        setDistrictId('')
                        setDistrictList([])
                        setSubDistrictId('')
                        setSubDistrictList([])
                        getDistrictList(e)
                    }} list={provinceList}></Select>
                    <Select placeholder="อำเภอ" value={districtId} setValue={(e) => {
                        setDistrictId(e)
                        setSubDistrictId('')
                        setSubDistrictList([])
                        getSubDistrictList(e)
                    }} list={districtList}></Select>
                    <Select placeholder="ตำบล" value={subDistrictId} setValue={setSubDistrictId} list={subDistrictList}></Select> */}
          <Input
            regex={regex.postCode()}
            placeholder="รหัสไปรษณีย์"
            value={postCode}
            setValue={setPostCode}
          ></Input>
        </div>
        <div
          style={{
            display: "flex",
            alignItems: "center",
            gridGap: 20,
            margin: "20px 0px",
          }}
        >
          <div>เลือกหน้าที่</div>
          <div className={styles.subTitle}>(เลือกได้มากกว่า 1 ข้อ)</div>
          <div className={styles.checkboxContainer}>
            <input
              id="analyst"
              checked={analystCheck}
              onChange={(e) => {
                setAnalystCheck(e.target.checked);
              }}
              type="checkbox"
            ></input>
            <div className={styles.subTitle}>ผู้วิเคราะห์</div>
          </div>
          <div className={styles.checkboxContainer}>
            <input
              id="approver"
              checked={approverCheck}
              onChange={(e) => {
                setApproverCheck(e.target.checked);
              }}
              type="checkbox"
            ></input>
            <div className={styles.subTitle}>ผู้รับรองผล</div>
          </div>
        </div>
        <div className={styles.title}>คำร้องขอใช้ระบบ</div>
        <div
          className={styles.subTitle}
          style={{ margin: "0px 0px 20px 0px", width: "880px" }}
        >
          สำหรับนักวิทยาศาสตร์การแพทย์
          หรือเจ้าหน้าที่ในวิชาชีพที่ไม่มีเลขใบประกอบวิชาชีพเพื่อให้ผู้ดูแลระบบในระดับห้องปฏิบัติการรับรองและอนุญาตการทำงานของเจ้าหน้าที่
        </div>
        <div className={styles.fileContainer}>
          <Button
            onClick={() => {
              inputFileRef.current.click();
            }}
            style={{ gridGap: 10 }}
          >
            <img
              style={{ width: 24, height: 24 }}
              src={require("../../asset/icon/attach-file-icon.svg").default}
            ></img>
            <div>แนบไฟล์</div>
          </Button>
          <input
            type={"file"}
            ref={inputFileRef}
            onChange={(e) => {
              inputFileChange(e);
            }}
            style={{ display: "none" }}
          ></input>
          {attachFile ? <div>{attachFile.file_name}</div> : null}
        </div>
        <div className={styles.title}>บัญชีผู้ใช้</div>
        <div className={styles.alignAll}>
          <Input
            disabledLabel
            placeholder="ชื่อผู้ใช้งาน (ตั้งชื่อเพื่อใช้แสดงผลบนหน้าบัญชีผู้ใช้)"
            value={userName}
            setValue={setUserName}
          />
          {/* <div></div> */}
        </div>
        <div className={styles.alignAll}>
          <div>
            <PasswordInput
              regex={regex.password()}
              placeholder="รหัสผ่าน"
              label="รหัสผ่าน"
              value={password}
              setValue={setPassword}
            />
            <div className={styles.formDetail}>
              รหัสควรประกอบด้วย ตัวอักษรภาษาอังกฤษอย่างน้อย 1 ตัว และตัวเลข
            </div>
          </div>
          <PasswordInput
            regex={regex.password()}
            placeholder="ยืนยันรหัสผ่าน"
            value={confirmPassword}
            setValue={setconfirmPassword}
          />
        </div>

        <div
          className={styles.alignButton}
          style={{ justifyContent: "center", margin: "30px 0px 30px 0px" }}
        >
          <Button
            style={{ background: "#ffffff", width: "150px" }}
            onClick={() => {
              nav("/manageUsersOperation");
            }}
          >
            ย้อนกลับ
          </Button>
          <Button style={{ width: "150px" }} onClick={submitButtonClick}>
            ถัดไป
          </Button>
        </div>
      </div>
    </div>
  );
}
export default AddOperationStaff;
